// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiXTdhGrantStatus } from '../models/ApiXTdhGrantStatus';
import { ApiXTdhGrantTargetChain } from '../models/ApiXTdhGrantTargetChain';
import { HttpFile } from '../http/http';

export class ApiXTdhGrant {
    'id': string;
    'grantor': ApiProfileMin;
    'target_chain': ApiXTdhGrantTargetChain;
    'target_contract': string;
    'target_tokens_count': number;
    'target_collection_name': string | null;
    'created_at': number;
    'updated_at': number;
    'valid_from': number | null;
    'valid_to': number | null;
    'rate': number;
    'error_details': string | null;
    'status': ApiXTdhGrantStatus;
    /**
    * If true then the grant must be covered with lock contracts
    */
    'is_irrevocable': boolean;
    'total_granted': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "grantor",
            "baseName": "grantor",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "target_chain",
            "baseName": "target_chain",
            "type": "ApiXTdhGrantTargetChain",
            "format": ""
        },
        {
            "name": "target_contract",
            "baseName": "target_contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "target_tokens_count",
            "baseName": "target_tokens_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "target_collection_name",
            "baseName": "target_collection_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "valid_from",
            "baseName": "valid_from",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "valid_to",
            "baseName": "valid_to",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rate",
            "baseName": "rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "error_details",
            "baseName": "error_details",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ApiXTdhGrantStatus",
            "format": ""
        },
        {
            "name": "is_irrevocable",
            "baseName": "is_irrevocable",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "total_granted",
            "baseName": "total_granted",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiXTdhGrant.attributeTypeMap;
    }

    public constructor() {
    }
}


